import PropTypes from 'prop-types';

const ChecklistSchoolGroup = {
  id: PropTypes.string,
  name: PropTypes.string,
  location: PropTypes.string,
  last_edited_by: PropTypes.string,
  created_at: PropTypes.string,
  updated_at: PropTypes.string
};

export default ChecklistSchoolGroup;
